import React, { useState, useEffect } from 'react'
import useMedia from 'use-media'
import { FlyToInterpolator } from 'react-map-gl'
import { useLocation, navigate } from '@reach/router'
import qs from 'qs'
import isEqual from 'lodash.isequal'
import { Configure } from 'react-instantsearch-dom'
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons'

import InstantSearch from '../../atoms/InstantSearch'
import Theme from '../../atoms/Theme'
import Container from '../../atoms/Container'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'
import Placeholder from '../../atoms/Placeholder'
import Button from '../../atoms/Button/Button'
import MobileFixed from '../../atoms/Search/MobileFixed'
import Icon from '../../atoms/Icon'

import Hits from '../../molecules/Search/Hits'
import Pagination from '../../molecules/Search/Pagination'
import Header from '../../molecules/Search/Header'
import HitsPerPage from '../../molecules/Search/HitsPerPage'

import Navbar from '../../organisms/Navbar'
import Footer from '../../organisms/Footer'
import Card from '../../organisms/ApartmentCardVersion2'
import GeoSearch from '../../organisms/Map/GeoSearch'
import SearchForm from '../../organisms/SearchForm'

import Page from '../Blank/Page'

import Main from '../LandingPage/Main'
import Aside from '../LandingPage/Aside'
import CardWrapper from '../LandingPage/CardWrapper'

import { urlToSearchState, searchStateToUrl } from '../../helpers'

export default ({ searchClient, ...props }) => {
  const location = useLocation()
  const { trackingData, menu, logo, footer, markets, pricingDisclaimer, version } = props
  const [show, setShow] = useState()
  const [loaded, setLoaded] = useState()
  const [viewport, setViewport] = useState({})
  const [popup, setPopup] = useState()
  const [searchState, setSearchState] = useState(urlToSearchState(location))
  const [highlight, setHighlight] = useState()

  const isMobile = useMedia({ maxWidth: '767.9px' })

  const toggleMap = () => {
    setShow(show === 'map' ? '' : 'map')
    setLoaded(true)
  }

  const closePopup = () => setPopup()
  const showPopup = apartment => {
    setPopup(apartment)
    const offset = 105 / 2 ** viewport.zoom
    setViewport({
      ...viewport,
      transitionDuration: 1000,
      transitionInterpolator: new FlyToInterpolator(),
      latitude: apartment.coordinates.lat + offset,
      longitude: apartment.coordinates.lng,
    })
  }

  const toggleForm = () => setShow(show === 'form' ? '' : 'form')

  // TODO: make a hook for disabling body scroll
  useEffect(() => {
    const classList = document.body.className.split(/ +/)
    const className = 'noscroll'

    const index = classList.indexOf(className)
    if (index > -1) classList.splice(index, 1)
    if (show) classList.push(className)

    document.body.className = classList.join(' ')

    return () => document.body.classList.remove('noscroll')
  }, [show])

  useEffect(() => {
    setSearchState(urlToSearchState(location))
  }, [location])

  useEffect(() => {
    if (isMobile && !loaded) {
      const { start = 'form' } = searchState
      setShow(start)
    }
  }, [isMobile, searchState, loaded])

  const onSearchStateChange = ss => {
    const { menu: newMenu, boundingBox, ...newSearchState } = ss
    if (!isEqual(searchState.menu, newMenu))
      newSearchState.menu = newMenu
    else if (!isEqual(searchState.boundingBox, boundingBox))
      newSearchState.boundingBox = boundingBox
    else if (searchState.menu)
      newSearchState.menu = searchState.menu
    else if (searchState.boundingBox)
      newSearchState.boundingBox = searchState.boundingBox

    setSearchState(newSearchState)

    if (!isEqual(newSearchState, searchState)) {
      navigate(location.pathname + searchStateToUrl(newSearchState))
    }
  }

  return (
    <Theme>
      <InstantSearch searchState={searchState} onSearchStateChange={onSearchStateChange} searchClient={searchClient}>
        <Configure analytics clickAnalytics sortFacetValuesBy='alpha' />
        <Page trackingData={trackingData}>
          <Navbar {...{ menu, logo }} />
          <Main>
            <Container>
              <Row as='section'>
                <Col>
                  <SearchForm
                    show={show === 'form'}
                    type='gray50'
                    setShow={toggleForm}
                    markets={markets.items}
                  />
                  <HitsPerPage />
                  <MobileFixed>
                    <Button type='secondary' onClick={toggleForm}>
                      Filter
                    </Button>
                    {isMobile ? (
                      <Button type='secondary' onClick={toggleMap}>
                        <Icon fixedWidth icon={show === 'map' ? faTimes : faMapMarkerAlt} />
                      </Button>
                    ) : null}
                  </MobileFixed>
                  <Header />
                  <small>{pricingDisclaimer}</small>
                  <Row>
                    <Hits
                      components={{ CardWrapper, Card }}
                      setHighlight={setHighlight}
                      showPopup={showPopup}
                      isMobile={isMobile}
                      version={version}
                    />
                  </Row>
                  <Pagination />
                </Col>
              </Row>
            </Container>
          </Main>
          <Aside show={show === 'map'}>
            {!isMobile || show === 'map' || loaded ? (
              <GeoSearch
                onLoad={() => setLoaded(true)}
                {...{ viewport, setViewport, popup, showPopup, closePopup, highlight }}
              />
            ) : (
              <Placeholder />
            )}
          </Aside>
          <Footer width={0.6667} {...footer} />
        </Page>
      </InstantSearch>
    </Theme>
  )
}
